import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseMenuIcon from '../../assets/closeDesktop.svg';
import ArrowBackLeft from '../../assets/box-arrow-left.svg';
import styles from './MenuComponent.module.scss';
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { clearSelectedMessage, closeMenu } from "../../store/slices/appSlice";
import classNames from "classnames";
const CloseMenu = ({ left }) => {
    const dispatch = useAppDispatch();
    const isSend = useAppSelector(state => state.app.isSendMessage);
    const handleClick = () => {
        if (isSend)
            dispatch(clearSelectedMessage());
        dispatch(closeMenu());
    };
    return (_jsxs("div", { className: styles.close, children: [_jsx("div", { className: classNames(styles.closeMobile, { [styles.closeMenuLeft]: left }), children: _jsx(ArrowBackLeft, { fontSize: '1.5rem', onClick: handleClick }) }), _jsx("div", { className: styles.closeDesktop, children: _jsx(CloseMenuIcon, { fontSize: '1.3rem', cursor: 'pointer', onClick: handleClick }) })] }));
};
export default CloseMenu;
